import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  BpmByNDCAndJobTypePayload,
  BpmByNDCAndJobTypeResponse,
  BpmByNDCAndJobTypeSingleResponse,
  FgNDCResponse
} from 'Interfaces/ReferenceInterfaces/StandardAndRecipeBpmInterface';

export const bpmByNdcAndJobTypeServices = {
  getAllBpmByNdcAndJobTypes: (
    page = 1,
    pageSize = 10000,
    search?: string
  ): Promise<BpmByNDCAndJobTypeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        let url = `pps/bpm-by-ndc-and-job-types?page=${page}&page_size=${pageSize}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }

        const { data } = await getRequest<BpmByNDCAndJobTypeResponse>(url);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getBpmByNdcAndJobTypeById: (id: number): Promise<BpmByNDCAndJobTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<BpmByNDCAndJobTypeSingleResponse>(
          `pps/bpm-by-ndc-and-job-types/${id}/`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createBpmByNdcAndJobType: (
    bpmByNdcAndJobTypeData: BpmByNDCAndJobTypePayload
  ): Promise<BpmByNDCAndJobTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<BpmByNDCAndJobTypeSingleResponse>(
          'pps/bpm-by-ndc-and-job-types/',
          bpmByNdcAndJobTypeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateBpmByNdcAndJobType: (
    id: number,
    bpmByNdcAndJobTypeData: BpmByNDCAndJobTypePayload
  ): Promise<BpmByNDCAndJobTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<BpmByNDCAndJobTypeSingleResponse>(
          `pps/bpm-by-ndc-and-job-types/${id}/`,
          bpmByNdcAndJobTypeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteBpmByNdcAndJobType: (id: number): Promise<BpmByNDCAndJobTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest<BpmByNDCAndJobTypeSingleResponse>(
          `pps/bpm-by-ndc-and-job-types/${id}/`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getAllFgNDC: (): Promise<FgNDCResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<FgNDCResponse>(
          'pps/drug-reference-fg-ndcs/get-all-ndc-descriptions/'
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
